export enum Role {
  Admin = 'ROLE_ADMIN',
  DesAdmin = 'ROLE_DES_ADMIN',
  DesGod = 'ROLE_DES_GOD',
}

export const ADMIN_ROLES: Role[] = [Role.Admin, Role.DesAdmin, Role.DesGod];

export type RouteConfig = {
  url: string;
  roles: Role[];
};

export const RUTAS_CONFIG: Record<string, RouteConfig> = {
  TICKETS: { url: '/tickets', roles: ADMIN_ROLES },
  CLIENTES: { url: '/clientes', roles: [] },
  BONOS: { url: '/bonos', roles: ADMIN_ROLES },
  BONOCLIENTES: { url: '/bonoclientes', roles: [] },
  CAJA_CIERRE: { url: '/caja/cierrecaja', roles: [] },
  CAJA_ARQUEO: { url: '/caja/arqueocaja', roles: [] },
  PAGOS: { url: '/pagos', roles: [] },
  DEVOLUCIONES: { url: '/devoluciones', roles: [] },
  PRODUCTOS: { url: '/productos', roles: ADMIN_ROLES },
  SERVICIOS: { url: '/servicios', roles: ADMIN_ROLES },
  SERVICIOS_TIPOS: { url: '/servicios/tipos', roles: ADMIN_ROLES },
  CONFIGURACIONES: { url: '/configuraciones', roles: ADMIN_ROLES },
  USUARIOS: { url: '/usuarios', roles: ADMIN_ROLES },
  TIENDAS: { url: '/tiendas', roles: ADMIN_ROLES },
  INFORMES: { url: '/informes', roles: ADMIN_ROLES },
  ALBARANES: { url: '/albaranes', roles: ADMIN_ROLES },
  DESARROLLO: { url: '/desarrollo', roles: [Role.DesGod] },
};

export function getRolesForUrl(url: string): Role[] | null {
  const cleanedUrl = url.split('?')[0].split('#')[0];

  const routeEntries = Object.values(RUTAS_CONFIG);

  const exactMatch = routeEntries.find((route) => route.url === cleanedUrl);
  if (exactMatch) {
    return exactMatch.roles;
  }

  let bestMatch: RouteConfig | null = null;

  routeEntries.forEach((route) => {
    if (cleanedUrl === route.url || cleanedUrl.startsWith(route.url + '/')) {
      if (!bestMatch || route.url.length > bestMatch.url.length) {
        bestMatch = route;
      }
    }
  });

  return bestMatch ? bestMatch.roles : null;
}
